import { render, staticRenderFns } from "./pc-header-nav.vue?vue&type=template&id=79d4a0c3&scoped=true&lang=pug&"
import script from "./pc-header-nav.vue?vue&type=script&lang=js&"
export * from "./pc-header-nav.vue?vue&type=script&lang=js&"
import style0 from "./pc-header-nav.vue?vue&type=style&index=0&id=79d4a0c3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d4a0c3",
  null
  
)

export default component.exports